import { Grid } from "@mui/material";
import { PermissionProvider } from "../../../context/SuperAdmin/PermissionContext";
import { useSuperAdminSingleRol } from "../../../context/SuperAdmin/SingleRoleContext";
import { UserRoleProvider } from "../../../context/SuperAdmin/UserRoleContext";
import { CustomTab, CustomTabs } from "../Auditoria/CustomItems";
import SingleRolePermissions from "./Permissions/SingleRolePermissions";
import SingleRoleUsers from "./Users/SingleRoleUsers";

const TabsSingleRole = () => {
  const { isPermissionsTab, setIsPermissionsTab } = useSuperAdminSingleRol();
  return (
    <Grid item>
      {/* Selección de tab Usuarios o Suborganizaciones */}
      <CustomTabs
        value={isPermissionsTab}
        onChange={(_, newValue: 0 | 1) => setIsPermissionsTab(newValue)}
        variant="fullWidth"
      >
        <CustomTab label="Permisos" />
        <CustomTab label="Usuarios" />
      </CustomTabs>

      {/* Tab seleccionada. Si es 0, será Usuarios */}
      {isPermissionsTab === 0 ? (
        <PermissionProvider isPermissionsTab={isPermissionsTab}>
          <SingleRolePermissions />
        </PermissionProvider>
      ) : (
        <UserRoleProvider isPermissionsTab={isPermissionsTab}>
          <SingleRoleUsers />
        </UserRoleProvider>
      )}
    </Grid>
  );
};

export default TabsSingleRole;
